import { atom } from "jotai";
import type { YouTubePlayer } from "youtube-player/dist/types";

export type ScmpYoutubePlayer = {
  scmpYoutubePlayer?: YouTubePlayer;
};

export const scmpYoutubePlayerAtom = atom<ScmpYoutubePlayer>({
  scmpYoutubePlayer: undefined,
});
